import { Divider } from "@fluentui/react-components";
import { Switch, SwitchOnChangeData, Text } from "@fluentui/react-components";
import { useAtom } from "jotai";
import { SelectItem } from "library/types";
import { useTranslation } from "react-i18next";
import { benefitCardImageAtom, darkModeAtom } from "store";
import styled from "styled-components";

import { NavFooterContent } from "components/NavFooterContent/NavFooterContent";
import { SelectClient } from "components/SelectClient/SelectClient";
import { Flex } from "components/styled";

import { SelectLanguage } from "../../SelectLanguage";
import { ThemeSettings } from "../../ThemeSettings";

interface IProps {
  togglePanel: () => void;
  languageOptions: SelectItem[];
  onSelect: (event: React.FormEvent<HTMLDivElement>, option?: SelectItem, index?: number) => void;
  selectedLanguage: string;
}

export const SettingsPanel = ({
  togglePanel,
  languageOptions,
  onSelect,
  selectedLanguage,
}: IProps) => {
  const { t } = useTranslation();
  const [showImages, setShowImages] = useAtom(benefitCardImageAtom);
  const [isDarkMode, setIsDarkMode] = useAtom(darkModeAtom);
  return (
    <Container>
      <SelectClient togglePanel={togglePanel} />
      <Wrap>
        <Flex width={"200px"}>
          <SelectLanguage
            languageOptions={languageOptions}
            onSelect={onSelect}
            selectedLanguage={selectedLanguage}
          />
        </Flex>
        <Divider />
        <ThemeSettings />
        <Divider />
        <SwitchWrap>
          <Flex width={"100%"} $justify="space-between">
            <Text>{t("hbh.cardImage.label")}</Text>
            <Switch
              defaultChecked={showImages}
              onChange={(_, data: SwitchOnChangeData) => {
                setShowImages(!!data.checked);
              }}
              indicator={{
                style: {
                  margin: 0,
                },
              }}
            />
          </Flex>
          <Flex data-help="app-settings-dark-mode" width={"100%"} $justify="space-between">
            <Text>{t("header.DarkMode")}</Text>
            <Switch
              defaultChecked={isDarkMode}
              onChange={(_, data: SwitchOnChangeData) => {
                setIsDarkMode(!!data.checked);
              }}
              indicator={{
                style: {
                  margin: 0,
                },
              }}
            />
          </Flex>
        </SwitchWrap>
        <Divider />
        <FooterWrap>
          <NavFooterContent togglePanel={togglePanel} />
        </FooterWrap>
      </Wrap>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  height: 100%;
`;
const Wrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 20px;
`;
const SwitchWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 200px;
`;

const FooterWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
`;
